import { Button, Text, VSpacer } from '@/components/DesignSystem';
import { TextBadge } from '@/components/DesignSystem/TextBadge/TextBadge';
import Add from '@mui/icons-material/Add';
import { alpha, Stack } from '@mui/material';

const ENERGY_BADGE_COLOR = '#67790F';

export type EnergyProgramEmptyStateContext = 'branding' | 'overview' | 'program';

const SUBLINE_BY_CONTEXT: Record<EnergyProgramEmptyStateContext, string> = {
  branding: 'Add an Energy program to configure its branding assets.',
  overview: 'Add an Energy program to see performance summaries here.',
  program: 'Add an Energy program to configure rewards, wallet, and cutoff settings.',
};

interface EnergyProgramEmptyStateProps {
  context: EnergyProgramEmptyStateContext,
  onAdd: () => void,
  testID: string,
}

export const EnergyProgramEmptyState = ({
  context,
  onAdd,
  testID,
}: EnergyProgramEmptyStateProps) => {
  return (
    <Stack alignItems="center" data-testid={testID} sx={{ px: '24px', py: '32px' }}>
      <Stack alignItems="center" direction="row" spacing={1}>
        <TextBadge
          backgroundColor={alpha(ENERGY_BADGE_COLOR, 0.12)}
          text="ENERGY"
          textColor={ENERGY_BADGE_COLOR}
        />
        <Text category="title-small" testID={`${testID}-heading`}>
          Energy Program
        </Text>
      </Stack>
      <VSpacer size="3" />
      <Text
        category="body-medium"
        sx={{ color: 'text.secondary', maxWidth: '360px' }}
        testID={`${testID}-subline`}
        textAlign="center"
      >
        {SUBLINE_BY_CONTEXT[context]}
      </Text>
      <VSpacer size="6" />
      <Button
        color="primary"
        onClick={onAdd}
        startIcon={<Add />}
        testID={`${testID}-add-button`}
        variant="outlined"
      >
        Add Energy Program
      </Button>
    </Stack>
  );
};
